module.exports = "pegasus/assets/blocks/column-14-theme5.png";